import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-address-capture-indonesia',
  templateUrl: './address-capture-indonesia.component.html',
  styleUrls: ['./address-capture-indonesia.component.scss']
})
export class AddressCaptureIndonesiaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }
  savedAdd
  radioValue
  line1
  line2
  city
  province
  coc
  filteredOptions
  
  onInput(data){} 

  list = [
    1,2,3
]

}
